export const JOURNEY_CARD_LAST_SHOWN_KEY = 'sparkapp_journey_card_last_shown';

/** Returns the ISO timestamp string of when the journey card was last shown, or null. */
export function getJourneyCardLastShown(): string | null {
  try {
    return localStorage.getItem(JOURNEY_CARD_LAST_SHOWN_KEY);
  } catch {
    return null;
  }
}

/** Records the current time as the last time the journey card was shown. */
export function recordJourneyCardShown(): void {
  try {
    localStorage.setItem(JOURNEY_CARD_LAST_SHOWN_KEY, new Date().toISOString());
  } catch {
    // localStorage unavailable — non-critical, silently ignore
  }
}
